import React from "react";
import { EventData } from "../types/chatbot.types";

interface ReferralOptionsProps {
	eventdata: EventData[];
	showReferralOptions: boolean;
	showReferralForm: boolean;
	onSelectClick: () => void;
	onReferralItemClick: (index: number, event: EventData) => void;
}

const ReferralOptions: React.FC<ReferralOptionsProps> = ({
	eventdata,
	showReferralOptions,
	showReferralForm,
	onSelectClick,
	onReferralItemClick,
}) => {
	return (
		<>
			<div
				className="referral-container"
				style={{
					display:
						eventdata.length > 0 && !showReferralOptions && !showReferralForm
							? "block"
							: "none",
				}}
			>
				<div className="referral-header">
					You have a referral form ready to complete ...
				</div>
				<div className="referral-section">
					<div className="referral-content">
						<span className="referral-title">Referrals</span>
						<span className="referral-subtitle">
							{" "}
							{eventdata.length} Relevant Referral Forms
						</span>
					</div>
					<button className="select-button" onClick={onSelectClick}>
						Select
					</button>
				</div>
			</div>

			{eventdata.length > 0 && showReferralOptions && (
				<div className="referrals-main">
					<div className="referrals-container">
						<div className="referrals-header">
							<span className="header-title">Referrals</span>
							<button className="complete-all-btn">Complete all</button>
						</div>

						<div className="referral-items">
							{eventdata.map((event, index) => (
								<div className="referral-item" key={index}>
									<span>{event.formId}</span>
									<button
										className="complete-btn"
										onClick={() => onReferralItemClick(index, event)}
									>
										open
									</button>
								</div>
							))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ReferralOptions;
